import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sinu ON24 raha jääk on <span style="color:#a6d189;">**{kontoraha}**</span>,
mille abil saad \(soodus\)hinnast \(<span style="color:#a6d189;">**{soodushind}**</span>\)
omakorda <span style="color:#a6d189;">**{kontosoodus}**</span> soodustust.
Kauba lõplik summa sulle on <span style="color:#a6d189;">**{sum}**</span>.

  <span style="color:#85c1dc;">**FI:**</span>
  ON24-tilisi saldo on <span style="color:#a6d189;">**{kontoraha}**</span>,
jolla saat \(tarjous\)hinnasta \(<span style="color:#a6d189;">**{soodushind}**</span>\)
omakorda <span style="color:#a6d189;">**{kontosoodus}**</span> alennusta.
Tilauksen lopullinen hinta sinulle on <span style="color:#a6d189;">**{sum}**</span>.

  <span style="color:#85c1dc;">**RU:**</span>
  Остаток на Вашем клиентском счете <span style="color:#a6d189;">**{kontoraha}**</span>,
с помощью которых Вы получите ещё скидку \(<span style="color:#a6d189;">**{soodushind}**</span>\)
<span style="color:#a6d189;">**{kontosoodus}**</span> с льготной цены.
Сумма товаров для Вас <span style="color:#a6d189;">**{sum}**</span>.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1007 = msg(
  mf`Sinu ON24 raha jääk on ${'kontoraha'},
mille abil saad (soodus)hinnast (${'soodushind'})
omakorda ${'kontosoodus'} soodustust.
Kauba lõplik summa sulle on ${'sum'}.`,
  mf`ON24-tilisi saldo on ${'kontoraha'},
jolla saat (tarjous)hinnasta (${'soodushind'})
omakorda ${'kontosoodus'} alennusta.
Tilauksen lopullinen hinta sinulle on ${'sum'}.`,
  mf`Остаток на Вашем клиентском счете ${'kontoraha'},
с помощью которых Вы получите ещё скидку (${'soodushind'})
${'kontosoodus'} с льготной цены.
Сумма товаров для Вас ${'sum'}.`,
)

export { m1007 as 'w.basket.summary.customer_discount.tooltip2' }